import { render, staticRenderFns } from "./productdetaliy.vue?vue&type=template&id=8f7a866e&scoped=true&"
import script from "./productdetaliy.vue?vue&type=script&lang=js&"
export * from "./productdetaliy.vue?vue&type=script&lang=js&"
import style0 from "./productdetaliy.vue?vue&type=style&index=0&id=8f7a866e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7a866e",
  null
  
)

export default component.exports